<template>
  <div class="message-new-receivers">

    <div class="row row-tabs mt-3">
      <div class="col-12 receivers-title mb-2">
        <h1>Empfänger hinzufügen</h1>
        <button @click="goBack" class="go-back btn-cursor">
          <img :src="'./static/img/' + $current_user.role +'/nav_back.png'">
        </button>
        <button @click="goBack" class="btn-confirm-add btn-cursor">
          <img class="icon mr-3" :src="'./static/img/' + $current_user.role +'/nav_hinzufugen.png'">
        </button>
      </div>

      <div class="col-12 mb-4 receivers-filtering">
        <form class="search-form mt-2">
          <div class="input-group">
            <input v-model="search" id="filter-input" class="input-search" placeholder="Suche" name="search-message" autofocus>
            <div class="input-group-btn">
              <button class="btn btn-search" type="submit" disabled>
                <img v-if="search === ''" src="~assets/img/search.png" class="icon-search"/>
                <img v-else @click="clearSearch" src="~assets/img/search_close.png" class="icon-search btn-cursor"/>
              </button>
            </div>
          </div>
        </form>
      </div>

      <div class="col-12">
        <b-table v-if="contacts.length !== 0" hover :items="filteredList" :fields="fields" @row-clicked="addReceiver" tbody-tr-class="btn-cursor" :thead-class="[{'hidden-on-search': isSearch}]">
          <template slot="HEAD_title" slot-scope="row" class="hidden-on-search">
            An Alle
          </template>
          <template slot="receiver" slot-scope="row">
            {{ title }}
          </template>
          <template slot="HEAD_action" slot-scope="data" class="hidden-on-search">
            <input v-model="allSelected" id="add-all" type="checkbox">
            <label @click="addAllReceivers()" for="add-all"></label>
          </template>
          <template slot="action" slot-scope="row">
            <input :id="row.item.itemid" :checked="selectedReceivers.includes(row.item)" type="checkbox" :value="row.item.itemid" @click.stop="">
            <label :for="row.item.itemid"></label>
          </template>
        </b-table>
        <div v-else class="text-center">
          Sie haben noch keine SchülerInnen zu Ihrer Pinnwand angelegt.
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  props: ['contacts', 'selectedReceivers', 'add', 'goBack'],
  data() {
    return {
      fields: ['title', { key: 'action', class: 'text-right' }],
      allSelected: false,
      search: '',
    };
  },
  methods: {
    addReceiver(item) {
      const ids = this.selectedReceivers;
      // eslint-disable-next-line
      ids.includes(item) ? ids.splice(ids.indexOf(item), 1) : ids.push(item);
    },
    addAllReceivers() {
      this.selectedReceivers.splice(0, this.selectedReceivers.length);
      if (!this.allSelected) this.selectedReceivers.push(...this.filteredList);
      this.allSelected = !this.allSelected;
    },
    clearSearch() {
      this.search = '';
      const searchinput = document.getElementById('filter-input');
      searchinput.focus();
    },
  },
  computed: {
    filteredList() {
      const query = this.search.toLowerCase();
      return this.contacts.filter(contact => contact.title.toLowerCase().includes(query));
    },
    isSearch() {
      return this.search.length > 0;
    },
  },
};
</script>

<style>
.hidden-on-search {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Messages/New/Receivers.vue